export const sortCodeRegexValidation = /^\d{2}-\d{2}-\d{2}$/
export const sortCodeRegexInput = RegExp(
  /(\d{1,2})-?(\d{1,2})?-?(\d{1,2})?(.*)/,
)
